import { MENU_ICON_SET_STYLE } from "../data/constants";
import {BackClass} from "./BackClass";
import { SliderDotTypeEnum } from "./CustomElement";
import { CustomStyleField } from "./CustomStyleField";
import {NodeTemplate} from "./NodeTemplate";
import {OnClickAction} from "./OnClickAction";
import { PageFormType } from "./PageFormType";

export interface TemplateNode {
    template?: NodeTemplate
}

export interface AdminSettings {
}

export enum HeaderSchemaVersion {
    Basic = 2,
}

export interface PageNode extends TemplateNode{
    /** Identifies the ready-made subpage template used to create this page. */
    subPageTemplateId?: number

    /**
     * This property for
     * @see src/components/context-menu/block/modules/containerSize.tsx:20
     */
    isMobileStyleContainerSize?: boolean

    /**
     * For color picking at mobile device
     */
    isMobileStyleColor?: boolean,

    /**
     * For url settings at mobile device
     */
    isMobileStyleStates?: boolean,

    /**
     * Show another text for mobile version
     */
    isMobileTextEnabled?:boolean

    /**
     * For background settings of div element
     */
    isMobileStyleBackground?: boolean,

    /**
     * For image elements
     */
    isMobileStyleImage?: boolean,

    /**
     * For icons
     */
    isMobileStyleIcon?: boolean


    customStyle?: CustomStyle|null,
    customStyleMobile?: CustomStyle|null,
    className?: string
    id: string,
    value?: string,
    mobileValue?: string,
    tagName?: string,
    /**
     * id of parent node
     */
    parentId: string,
    /**
     * This property classes which was entered by user
     */
    classes: string[],
    attributes?: { [key: string]: any }|null,

    /**
     * this is property which was entered by user
     */
    style?: object,
    styleString?: string,

    background?: string,

    /**
     * Hidden for desktop or mobile by user
     */
    hidden?: string

    /**
     * Hidden for user by admin
     */
    isHidden?: boolean,
    /**
     * This is classes for pc version
     */
    backClassesIndexed?: BackClass
    /**
     * This is classes for mobile version
     */
    backClassesMobile?: BackClass

    nodes:PageNode[]

    slideTemplate?: PageNode

    type: string

    /**
     * Item will be disallowed to add
     */
    disallowedAddElements?: boolean
    isNonEditable?: boolean
    breadCrumbTitle?: string
    onClickAction?: OnClickAction
    isMixedBorder?: boolean
    isMixedPadding?: boolean
    isMixedMargin?: boolean
    isMixedBorderRadius?: boolean
    isMobileMixedBorderRadius?:boolean
    isMobileMixedBorder?: boolean
    isMobileMixedPadding?: boolean
    isMobileMixedMargin?: boolean

    //TODO: change it to typed Node
    editSettings?:any
    //TODO: Тудаже
    selectedIcon?:any

    adminSettings?: AdminSettings
    vcardFileId?: number
    expanded?: boolean
    accordionIconClose?: string
    accordionIconOpen?: string
    iconPlace?: IconPlaceEnum
    textMobileClasses?: BackClass
    textClasses?: BackClass
    sliderLeftIcon?: string
    sliderRightIcon?: string
    isShowSliderIcons?: boolean
    isShowSliderDots?: boolean
    sliderDotType?: SliderDotTypeEnum
    isAutoscroll?: boolean
    autoscrollTime?: number
    iconStyles?: IconStyles
    indicatorStyles?: IconStyles
    fieldMode?: FieldMode
    analyticEvents?: AnalyticEvents
    socialSettings?: SocialSettings
    customStyleBackup?: CustomStyle | null
    burgerBehavior?: MenuPostion
    iconsSet?: MENU_ICON_SET_STYLE
    isSticky?: boolean
    isHeaderBtn?: boolean
    readyBlockId?: number
    schemaVersion?: HeaderSchemaVersion
    overlayStyle?: OverlayStyle
}

export interface OverlayStyle {
    background?: string;
    hAlign?: string;
    vAlign?: string;
    gap?: string;
}

export interface NodeWithTarget{
    target: string,
}
export interface ButtonNode extends PageNode,NodeWithTarget {
    buttonType?: string|null,
    href?: string|null,
    pageUrl?: string|null,
}

export interface IFrameNode extends PageNode{

}
export interface DivColNode  extends PageNode{
    /**
     * For size of div element
     */
    isMobileStyleContainerColSize?: boolean
    colSize?:number
    colSizeMobile?:number
}

export interface DivRowNode  extends PageNode{
    /**
     * Count of div col objects inside
     */
    structure?:number
    mobileStructure?:number
}

export interface ImageNode extends PageNode {
    /**
     * This is image settings for pc
     */
    src?: string|null,
    srcName?: string|null,
    srcSize?: number|null,
    loading?: "eager" | "lazy" | undefined,
    alt?: string|null,
    /**
     * This is image settings for mobile
     */
    srcMobile?: string|null,
    srcNameMobile?: string|null,
    srcSizeMobile?: number|null,
    loadingMobile?: "eager" | "lazy" | undefined,
    altMobile?: string|null

}

export type FormFieldType = 'text' | 'email' | 'textarea' | 'dropdown' | 'date';

export enum FormDateFormat {
    DayMonthYear = 'DD / MM / YYYY',
    MonthDayYear = 'MM / DD / YYYY',
    YearMonthDay = 'YYYY / MM / DD',
}

export interface FormFieldOption {
    id: string;
    label: string;
}

export interface FormField {
    id: string;
    label: string;
    placeholder: string;
    type: FormFieldType;
    required?: boolean;
    options?: FormFieldOption[];
    dateFormat?: FormDateFormat;
}

export interface FormStyles {
    form?: Record<string, string | number>;
    input?: Record<string, string | number>;
    floatingInput?: Record<string, string | number>;
    focusInput?: Record<string, string | number>;
    label?: Record<string, string | number>;
    floatingLabel?: Record<string, string | number>;
    placeholder?: Record<string, string | number>;
    textarea?: Record<string, string | number>;
    button?: Record<string, string | number>;
    buttonFocus?: Record<string, string | number>;
    buttonHover?: Record<string, string | number>;
    buttonError?: Record<string, string | number>;
}

export enum FormAfterSubmitAction {
    SuccessMessage = "successMessage",
    RedirectUrl = "redirectUrl",
}

export interface FormActions {
    emailNotifications?: boolean;
    notificationEmail?: string;
    afterSubmitAction?: FormAfterSubmitAction;
    successMessage?: string;
    redirectUrl?: string;
}

export interface FormNode extends PageNode {
    formSettings?: {
        uniqueKey?: string;
        type?: PageFormType;
        styleVersion?: number;
        submitLabel?: string;
        fields?: FormField[];
        styles?: FormStyles;
        actions?: FormActions;
    };
}

export enum NodeType {
    PageNode = 'PageNode',
    DivColNode = 'DivColNode',
    DivContainer = 'DivContainer',
    DivNode = 'DivNode',
    DivRowNode = 'DivRowNode',
    IFrameNode = 'IFrameNode',
    ButtonNode = 'ButtonNode',
    IconNode = 'IconNode',
    TextNode = 'TextNode',
    ImageNode = 'ImageNode',
    Accordion = 'Accordion',
    AccordionBodyNode = 'AccordionBodyNode',
    AccordionHeaderNode = 'AccordionHeaderNode',
    SliderNode = 'SliderNode',
    HeaderNode = 'HeaderNode',
    NavigationRegionsNode = 'NavigationRegionsNode',
    FormNode = 'FormNode'
}

export enum IconPlaceEnum {
    Right = 'right',
    Left = 'left'
}

export interface IconStyles {
    [CustomStyleField.FontSize]: number;
    [CustomStyleField.Color]: string
}

export enum NodeTagName {
    Image = "img",
    Iframe = "iframe"
}

export interface FieldMode {
    isEdit?: boolean;
    fieldName?: string;
    groupName?: string;
    actionFieldName?: string;
    isBackgroundSettings?: boolean;
}

export interface AnalyticEvents {
    googleEventName?: string
}

export interface SocialSettings {
    text: boolean,
    link: boolean,
    social: string
}

export enum MenuPostion {
    Top = 'top',
    Left = 'left',
    Right = 'right'
}
